// Template types that work with both Prisma and GraphQL data
// These define the minimum required shape - any object matching this interface will work
export var TemplateVariable;
(function (TemplateVariable) {
    TemplateVariable["FacilityNames"] = "facilityNames";
    TemplateVariable["CompanyName"] = "companyName";
})(TemplateVariable || (TemplateVariable = {}));
export var TemplateName;
(function (TemplateName) {
    /** @deprecated - use TierIIEmail instead*/
    TemplateName["TierIIEmailSingle"] = "tierIIEmailSingle";
    /** @deprecated - use TierIIEmail instead */
    TemplateName["TierIIEmailBulk"] = "tierIIEmailBulk";
    TemplateName["TierIIEmail"] = "tierIIEmail";
    TemplateName["OhioSerc"] = "ohioSerc";
    TemplateName["MailRoomFlexible"] = "mailRoomFlexible";
    /** Newly-not-reporting cover letter: default for most email states */
    TemplateName["NewlyNotReportingGeneral"] = "newlyNotReportingGeneral";
    /** Newly-not-reporting cover letter: A subset of Tier II Manager states (DE, IL, KY, PA, WI) */
    TemplateName["NewlyNotReportingT2M"] = "newlyNotReportingT2M";
    /** Newly-not-reporting cover letter: Arizona */
    TemplateName["NewlyNotReportingAZ"] = "newlyNotReportingAZ";
    /** Newly-not-reporting cover letter: Florida (Statement of Determination) */
    TemplateName["NewlyNotReportingFL"] = "newlyNotReportingFL";
    /** Newly-not-reporting cover letter: Idaho (SARA Title III Exemption Form) */
    TemplateName["NewlyNotReportingID"] = "newlyNotReportingID";
    /** Newly-not-reporting cover letter: New Jersey (CRTK Reporting Exemption Form) */
    TemplateName["NewlyNotReportingNJ"] = "newlyNotReportingNJ";
    /** Newly-not-reporting cover letter: Washington (EPCRA Section 312 Exemption) */
    TemplateName["NewlyNotReportingWA"] = "newlyNotReportingWA";
    TemplateName["Default"] = "default";
})(TemplateName || (TemplateName = {}));
//# sourceMappingURL=types.js.map